<template>
<div>
  <!-- Location Scanner Overlay -->
  <div v-if="showLocationOverlay" class="location-overlay">
    <div class="overlay-content">
      <h3 class="overlay-title">Scan Shelf QR Code</h3>
      <p class="overlay-subtitle">Please scan the QR code on the shelf to load location</p>
      <b-form-input
        ref="locationInput"
        v-model="scannedLocation"
        @keyup.enter="processScannedLocation"
        placeholder="Scan shelf code or enter location manually"
        class="location-input"
        size="lg"
      ></b-form-input>
      <div class="overlay-buttons">
        <b-button @click="processScannedLocation" variant="success" size="lg" class="me-2">
          Process Location
        </b-button>
        <b-button @click="closeLocationOverlay" variant="secondary" size="lg">
          Cancel
        </b-button>
      </div>
    </div>
  </div>

  <div v-if="allArticles.length" class="position-fixed col-3 bg-primary p-2" style="top: 7vh; left: 0.5vw; margin: 0;">
    <span>There are multiple products with that same EAN code:</span>
    <ul class="list-group">
      <li @click="chooseProduct(a)" v-for="(a, i) in allArticles" :key="i" class="list-group-item list-group-item-action pointer">
        {{a.name}}
      </li>
    </ul>
  </div>
  <div class="home">
    <div v-if="error" class="w-100 bg-danger p-3">{{error}}</div>
    <div v-if="show" class="text-center">
      <b-spinner variant="danger" label="Spinning"></b-spinner>
    </div>
    <div class="kartica" v-else>
      <b-container fluid class="my-3">
        <b-row class="equal-height-row">
          <b-col cols="6" class="d-flex align-items-center justify-content-center p-3 image-column bg-light">
            <h5>{{ article.name }}</h5>
            <b-img
              v-if="article.images && article.images.image && article.images.image[0]"
              :src="article.images.image[0].url"
              fluid
              alt="Product image"
              class="max-height-image"
            ></b-img>
          </b-col>
          <b-col cols="6" class="p-0 d-flex flex-column table-column bg-dark">
            <div class="table-container">
              <b-table
                :items="article.productCodes.productCode"
                head-variant="dark"
                sticky-header="37vh"
                responsive="sm"
                class="mb-0"
              >
              </b-table>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-card
        :header="article.codename"
        header-tag="header">
        <b-card-text>
          <div style="float:left">
            <span class="kolicina">{{article.localCount}}</span>
          </div>
          <div style="float:right">
            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="qtt('-')"
              class="dugmad"
              href="#"
              variant="danger">
              <b-icon-arrow-down></b-icon-arrow-down>
            </b-button>

            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="qtt('+')"
              class="dugmad"
              href="#"
              variant="success">
              <b-icon-arrow-up></b-icon-arrow-up>
            </b-button>
            <b-button size="lg"
              :disabled=disejblujKolicinu
              @click="saveQuantity"
              class="dugmad" href="#"
              variant="success">
              <b-icon-check></b-icon-check>
            </b-button>
          </div>
        </b-card-text>
      </b-card>

      <b-card
        style="margin-top:15px"
        :header="article.localLocation || 'No location'"
        header-tag="header">
        <b-form-select
        v-model="locationSelected.raf"
        :options="rafe"></b-form-select>
        <b-form-select
        class="mt-3"
        v-model="locationSelected.kolona"
        :options="kolone"></b-form-select>
        <b-form-select
        class="mt-3"
        v-model="locationSelected.red"
        :options="redovi"></b-form-select>
         <b-form-select
        class="mt-3"
        v-model="locationSelected.box"
        :options="boxovi"></b-form-select>
      <div style="float:right">
        <b-button size="lg"
          :disabled=disejblujLokaciju
          @click="openLocationScanner"
          class="dugmad" href="#"
          variant="info">
          <b-icon-upc-scan></b-icon-upc-scan>
        </b-button>
        <b-button size="lg"
          :disabled=disejblujLokaciju
          @click="saveLocation"
          class="dugmad" href="#"
          variant="success">
          <b-icon-check></b-icon-check>
        </b-button>
      </div>
      </b-card>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';

import fixed from '@/fixed';

export default {
  data() {
    return {
      error: '',
      show: true,
      disejblujKolicinu: true,
      disejblujLokaciju: true,
      allArticles: [],
      article: null,
      lok: {
        sku: '',
        location: 'LOCATION',
      },
      kolicina: {
        sku: '',
        qtt: 0,
      },
      rafe: fixed.locations.rafe,
      kolone: fixed.locations.kolone,
      redovi: fixed.locations.redovi,
      boxovi: [
        { value: null, text: 'Select box (optional)' },
      ],
      locationSelected: {
        raf: '',
        kolona: '',
        red: '',
        box: '',
      },
      showLocationOverlay: false,
      scannedLocation: '',
    };
  },
  created() {
    this.populateBoxes();
  },
  async mounted() {
    const uri = `${fixed.API_URL}/admin/scan/${this.$route.params.ean}`;
    try {
      const { data: { data } } = await axios.get(uri, { withCredentials: true });
      if (!data) { // if we don't have data we go back to scanner
        this.$toast.info('No article with that code');
        this.$router.push('/manual');
        return;
      }

      if (data.length > 1) {
        this.allArticles = data;
      }

      this.chooseProduct(data[0]);

      const opcije = this.article.localLocation ? this.article.localLocation.split(' ') : '';
      this.disejblujKolicinu = false;
      this.disejblujLokaciju = false;
      if (opcije.length > 1) {
        const [raf, kolona, red, box] = opcije;
        // eslint-disable-next-line object-curly-newline
        this.locationSelected = { raf, kolona, red, box };
      } else {
        this.showLocationOverlay = true;
        this.$nextTick(() => {
          this.$refs.locationInput.focus();
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this.error = 'you\'re not authorised for that action ✋🏻'; // eslint-disable-line
      } else {
        this.error = error;
      }
    }
    this.show = false;
  },
  methods: {
    chooseProduct(a) {
      this.article = a;
      if (!Object.hasOwn(this.article, 'localCount')) this.$set(this.article, 'localCount', 0);
    },
    qtt(operator) {
      if (operator === '-' && this.article.localCount < 1) return;

      if (operator === '+') {
        this.article.localCount += 1;
      } else {
        this.article.localCount -= 1;
      }
    },
    async saveLocation() {
      if (!this.locationSelected.raf || !this.locationSelected.kolona || !this.locationSelected.red) return; // eslint-disable-line

      const cleanBox = !this.locationSelected.box || this.locationSelected.box === ' ' || this.locationSelected.box === 'undefined' || this.locationSelected.box === 'null' ? '' : this.locationSelected.box;
      this.lok.location = `${this.locationSelected.raf} ${this.locationSelected.kolona} ${this.locationSelected.red} ${cleanBox}`;
      this.lok.sku = this.article.codename;

      const url = `${fixed.API_URL}/admin/location`;
      try {
        this.show = true;
        await axios.put(url, this.lok, { withCredentials: true });
        this.$toast.success('Saved successfully');
      } catch (error) {
        this.error = error;
      }
      this.show = false;
      this.article.localLocation = this.lok.location;
    },
    async saveQuantity() {
      this.kolicina.qtt = this.article.localCount;
      this.kolicina.sku = this.article.codename;

      const url = `${fixed.API_URL}/admin/quantity`;
      this.show = true;
      try {
        await axios.put(url, this.kolicina, { withCredentials: true });
        if (this.error) this.error = '';
        this.$toast.success('Saved successfully');
      } catch (error) {
        this.error = error.response.data;
      }
      this.show = false;
    },
    populateBoxes() {
      for (let i = 1; i <= 200; i += 1) {
        this.boxovi.push({ value: `Box${i}`, text: `Box ${i}` });
      }
    },
    processScannedLocation() {
      const location = this.scannedLocation.trim();
      if (!location) return;

      const parts = location.split(' ');
      if (parts.length < 3) {
        this.$toast.warning('Invalid location format. Please scan again.');
        return;
      }

      const [raf, kolona, red, box] = parts;
      this.locationSelected = {
        raf,
        kolona,
        red,
        box,
      };
      this.showLocationOverlay = false;
      this.saveLocation();
    },
    closeLocationOverlay() {
      this.showLocationOverlay = false;
      // this.$router.push('/manual');
    },
    openLocationScanner() {
      this.scannedLocation = '';
      this.showLocationOverlay = true;
      this.$nextTick(() => {
        this.$refs.locationInput.focus();
      });
    },
  },
};
</script>

<style>
.card {
  background-color: #343a40;
  color: aliceblue;
}
.card-header {
  font-size: 1.3rem;
}

.kartica {
  color: #222222
}
.kolicina {
  margin-left: 0.5rem;
  font-size: 2.6rem;
  font-weight: bold;
}
.dugmad {
  margin: 9px 0 0 6px;
}
.dugme {
  width: 85%;
  float: right;
}
.navi-dugme {
  position: fixed;
  bottom: 10px;
  width: 100vw;
}

.equal-height-row {
  min-height: 400px;
  display: flex;
}

.image-column, .table-column {
  display: flex;
  margin-top: 40px;
  flex-direction: column;
}

.max-height-image {
  max-height: 30vh;
  width: auto;
  object-fit: contain;
}

.table-container {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.table-container >>> .table.b-table {
  flex: 1;
}

.location-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.overlay-content {
  background-color: #343a40;
  padding: 2rem;
  border-radius: 0.5rem;
  text-align: center;
  width: 90%;
  max-width: 500px;
}

.overlay-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.overlay-subtitle {
  font-size: 1rem;
  margin-bottom: 2rem;
}

.location-input {
  background-color: #495057;
  color: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.75rem;
  width: 100%;
  margin-bottom: 1rem;
}

.overlay-buttons {
  display: flex;
  justify-content: space-between;
}
</style>
